import { useContext } from 'react'
import { ScreenWideReloadContext } from './ScreenWideReloadProvider'

export function useReload() {
  const { reload } = useContext(ScreenWideReloadContext)
  return { reload }
}
